import { render, staticRenderFns } from "./Dynamic-Button.vue?vue&type=template&id=44c0675e&scoped=true&"
import script from "./Dynamic-Button.vue?vue&type=script&lang=js&"
export * from "./Dynamic-Button.vue?vue&type=script&lang=js&"
import style0 from "./Dynamic-Button.vue?vue&type=style&index=0&id=44c0675e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c0675e",
  null
  
)

export default component.exports